<template>
	<section :class="`section other-programmes ${bg_color}`">
		<div class="container mx-auto">

			<h3 class="section-title px-4">Other Programmes</h3>

			<div class="programme-cards">
				<template v-for="(programme, o) in results" :key="o">
					<block-programme-card :payload="programme"></block-programme-card>
				</template>
			</div>

		</div>
	</section>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		name: 'ProgrammesRelated',
		props: {
			'id': {
				type: String
			},
      bg_color: {
        type: String,
        default: 'bg-white'
      }

		},
		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'prog-course-dev' : 'prog-course-live',
				searchObject: {
					hitsPerPage: 3,
					facets: ["prog-or-course"],
					facetFilters: [[`prog-or-course:Programme`]]
				},
				results: false
			}
		},
		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					// console.log("More jobs search raw results:", results);
					if (results.nbHits > 0) {
						this.filteredResults = results.hits.filter((el) => {
							return el['id'] !== this.id;
						});
						this.results = this.filteredResults.length ?  this.filteredResults : false;
					} else {
						this.results = false;
					}
				});
		},
		methods: {
      // Needs hooking up with other programme data

		}
	}
</script>
